import { InboxSeverity } from './inbox-item.model';

/** Mirrors the `ninety-notifications` inbox contract. Dates arrive as ISO strings over the wire. */

export type InboxAlertSource = 'system' | 'job' | 'userAction';
export type InboxAlertCategory = 'issues' | 'kpis' | 'billing' | 'general';

export enum InboxAlertView {
  active = 'active',
  archive = 'archive',
}

export interface InboxAlertCta {
  label: string;
  route: string;
}

export interface InboxAlertDTO {
  id: string;
  title: string;
  body: string;
  severity: InboxSeverity;
  source: InboxAlertSource;
  category: InboxAlertCategory;
  cta?: InboxAlertCta;
  createdAt: string;
  readAt?: string;
  resolvedAt?: string;
}

export interface InboxAlertListResponse {
  alerts: InboxAlertDTO[];
  hasMore: boolean;
  unreadCount: number;
}

export interface InboxConversationDTO {
  id: string;
  participantIds: string[];
  /** Null until the first message — a composed-but-empty thread has no activity. */
  lastMessageAt: string | null;
  lastMessagePreview: string;
  unread: boolean;
  createdAt: string;
}

export interface InboxConversationListResponse {
  conversations: InboxConversationDTO[];
  hasMore: boolean;
}

export interface InboxConversationMessageDTO {
  id: string;
  conversationId: string;
  authorUserId: string;
  body: string;
  createdAt: string;
}

export interface InboxConversationMessageListResponse {
  messages: InboxConversationMessageDTO[];
  hasMore: boolean;
}

/**
 * Alerts and conversations only — the server knows nothing about the notification feed, so the
 * badge adds the feed's unread count client-side (spec §6.4).
 */
export interface InboxCounts {
  alerts: number;
  conversations: number;
  total: number;
}
